import { getAllFacilities } from './getAllFacilities';
import { EFacilityType, type NonEmptyArray, type TJsonQuery } from './types';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

const SUBURBAN_FACILITIES: EFacilityType[] = [
  EFacilityType.Sauna,
  EFacilityType.Garage,
  EFacilityType.Security,
  EFacilityType.Pool,
  EFacilityType.Conditioner,
  EFacilityType.RoomFurniture,
  EFacilityType.KitchenFurniture,
  EFacilityType.Internet,
  EFacilityType.Fridge,
  EFacilityType.Dishwasher,
  EFacilityType.TV,
  EFacilityType.Washer,
];

export function getSuburbanFacilityTypes(jsonQuery: TJsonQuery): NonEmptyArray<EFacilityType> | null {
  const facilities = (getAllFacilities(jsonQuery) || []).filter(f => SUBURBAN_FACILITIES.includes(f));

  return nonEmptyArrayOr(facilities);
}
